import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../services/apiService'

const STATUS = {
  pending:  { bg: '#fef3c7', color: '#92400e', label: 'Pending' },
  approved: { bg: '#d1fae5', color: '#065f46', label: 'Approved' },
  rejected: { bg: '#fee2e2', color: '#991b1b', label: 'Rejected' },
}

const fmtDate = (d) => {
  if (!d) return '-'
  const dt = new Date(String(d).replace(' ', 'T'))
  if (isNaN(dt.getTime())) return d
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
}
const cap = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : ''

const AdminRegistrationRequests = () => {
  const navigate = useNavigate()
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')
  const [detail, setDetail] = useState(null)

  useEffect(() => { fetchRequests() }, [])

  const fetchRequests = async () => {
    try {
      setLoading(true)
      const res = await api.get('/client-admin/registration-requests')
      if (res.data.success) setRequests(res.data.data || [])
    } catch (e) {
      console.error('Error fetching registration requests:', e)
    } finally {
      setLoading(false)
    }
  }

  const shown = filter === 'all' ? requests : requests.filter(r => r.status === filter)
  const counts = {
    all: requests.length,
    pending: requests.filter(r => r.status === 'pending').length,
    approved: requests.filter(r => r.status === 'approved').length,
    rejected: requests.filter(r => r.status === 'rejected').length,
  }

  return (
    <div style={{ padding: '24px', maxWidth: '1100px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ margin: 0, color: '#c00f15', fontSize: '1.5rem' }}>
            <i className="fas fa-clipboard-check" style={{ marginRight: '10px' }}></i>Registration Requests
          </h2>
          <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: '0.9rem' }}>Review and approve or reject public player registration requests.</p>
        </div>
        <button onClick={() => navigate('/admin/dashboard')} style={{ height: '38px', padding: '0 18px', borderRadius: '8px', border: 'none', background: '#c00f15', color: '#fff', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <i className="fas fa-arrow-left"></i> Back
        </button>
      </div>

      {/* Filter tabs */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '18px', flexWrap: 'wrap' }}>
        {['all', 'pending', 'approved', 'rejected'].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{
            padding: '8px 16px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer',
            border: filter === f ? '2px solid #c00f15' : '2px solid #e5e7eb',
            background: filter === f ? '#c00f15' : '#fff', color: filter === f ? '#fff' : '#6b7280',
          }}>
            {cap(f)} ({counts[f]})
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#6b7280' }}><i className="fas fa-spinner fa-spin" style={{ fontSize: '1.5rem' }}></i></div>
      ) : shown.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', background: '#fff', borderRadius: '12px', color: '#9ca3af' }}>
          <i className="fas fa-inbox" style={{ fontSize: '2rem', display: 'block', marginBottom: '0.5rem' }}></i>
          No {filter === 'all' ? '' : filter} registration requests.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {shown.map(req => {
            const st = STATUS[req.status] || STATUS.pending
            return (
              <div key={req.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px 18px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '10px' }}>
                  <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                    {req.player_image
                      ? <img src={req.player_image} alt="" style={{ width: '52px', height: '52px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #eee' }} />
                      : <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: '#fdeaea', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-user" style={{ color: '#c00f15' }}></i></div>}
                    <div>
                      <div style={{ fontWeight: 700, color: '#1f2937', fontSize: '1rem' }}>{req.full_name}</div>
                      <div style={{ fontSize: '0.82rem', color: '#6b7280' }}>
                        {cap(req.member_type)} · {req.gender === 'M' ? 'Male' : 'Female'} · {req.state_name || '-'}
                      </div>
                      <div style={{ fontSize: '0.78rem', color: '#9ca3af', marginTop: '2px' }}>
                        <i className="fas fa-building" style={{ marginRight: '5px' }}></i>{req.association || '-'} &nbsp;·&nbsp; {req.created_at}
                      </div>
                    </div>
                  </div>
                  <span style={{ fontSize: '0.75rem', fontWeight: 700, padding: '4px 12px', borderRadius: '20px', background: st.bg, color: st.color, whiteSpace: 'nowrap' }}>{st.label}</span>
                </div>

                <div style={{ display: 'flex', gap: '8px', marginTop: '14px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <button onClick={() => setDetail(req)} style={btn('#e5e7eb', '#374151', '#fff')}><i className="fas fa-eye"></i> View Details</button>
                  {req.status === 'pending' && (
                    <span style={{ fontSize: '0.8rem', color: '#92400e', background: '#fef3c7', padding: '6px 12px', borderRadius: '20px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                      <i className="fas fa-envelope"></i> Approve / reject from the admin email
                    </span>
                  )}
                </div>

                {req.status === 'rejected' && req.rejection_reason && (
                  <div style={{ marginTop: '10px', fontSize: '0.82rem', color: '#991b1b', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '8px 12px' }}>
                    <i className="fas fa-info-circle" style={{ marginRight: '6px' }}></i>Reason: {req.rejection_reason}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}

      {/* Detail modal */}
      {detail && (
        <div onClick={() => setDetail(null)} style={overlay}>
          <div onClick={e => e.stopPropagation()} style={modal}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
              <h3 style={{ margin: 0, color: '#c00f15' }}><i className="fas fa-user-circle" style={{ marginRight: '8px' }}></i>Player Details</h3>
              <button onClick={() => setDetail(null)} style={{ background: 'none', border: 'none', fontSize: '1.2rem', cursor: 'pointer', color: '#6b7280' }}><i className="fas fa-times"></i></button>
            </div>
            {[['Full Name', detail.full_name], ["Father's Name", detail.father_name], ['Member Type', cap(detail.member_type)],
              ['Date of Birth', fmtDate(detail.date_of_birth)], ['Gender', detail.gender === 'M' ? 'Male' : 'Female'],
              ['Category', detail.category], ['State', detail.state_name], ['Email', detail.email], ['Contact', detail.contact],
              ['Association', detail.association], ['Requested By', detail.requester_name], ['Submitted', detail.created_at]
            ].map(([l, v]) => (
              <div key={l} style={{ display: 'flex', padding: '7px 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.86rem' }}>
                <div style={{ width: '140px', color: '#6b7280', fontWeight: 600 }}>{l}</div>
                <div style={{ color: '#1f2937' }}>{v || 'N/A'}</div>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  )
}

const btn = (border, color, bg) => ({
  display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 16px', borderRadius: '8px',
  border: `1px solid ${border}`, background: bg, color, fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer',
})
const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '20px' }
const modal = { background: '#fff', borderRadius: '14px', padding: '22px', width: '100%', maxWidth: '520px', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }

export default AdminRegistrationRequests
